import React from 'react';
import { useToast } from '../../context/ToastContext';
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle, FaTimes } from 'react-icons/fa';
import './Toast.css';

const ToastContainer = () => {
    const { toasts, removeToast } = useToast();

    const getIcon = (type) => {
        switch (type) {
            case 'success': return <FaCheckCircle size={20} />;
            case 'error': return <FaExclamationTriangle size={20} />;
            default: return <FaInfoCircle size={20} />;
        }
    };

    const getTitle = (type) => {
        switch (type) {
            case 'success': return 'Success';
            case 'error': return 'Error';
            default: return 'Info';
        }
    };

    return (
        <div className="toast-container">
            {toasts.map((toast) => (
                <div key={toast.id} className={`custom-toast ${toast.type}`}>
                    {getIcon(toast.type)}
                    <div className="toast-content">
                        <strong className="toast-title">{getTitle(toast.type)}</strong>
                        <span className="toast-message">{toast.message}</span>
                    </div>
                    <button className="toast-close-btn" onClick={() => removeToast(toast.id)}>
                        <FaTimes />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default ToastContainer;
